(function () {
  const PDF_HREF = /\.pdf(\?|#|$)/i;

  // Capture phase so this runs before other delegated click handlers
  // (e.g. page-transition.js on document.body and instant.page), which would
  // otherwise call preventDefault()/navigate and stop the modal from opening.
  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    // Let the browser handle intentional new-tab gestures.
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest('a[href]');
    if (!link) return;
    if (link.hasAttribute('data-no-pdf-modal')) return; // explicit opt-out: open externally

    const href = link.getAttribute('href');
    if (!href || !PDF_HREF.test(href)) return;

    const modal = document.getElementById('PdfModal');
    if (!modal || typeof modal.show !== 'function') return;

    const iframe = modal.querySelector('.pdf-modal__iframe');
    if (!iframe) return;

    // We're handling this PDF: block the link AND stop other click handlers
    // (page-transition / instant.page) from also acting on this event.
    event.preventDefault();
    event.stopPropagation();

    iframe.setAttribute('src', link.href);
    modal.show(link);

    const clearSrc = function () {
      if (!modal.hasAttribute('open')) {
        iframe.setAttribute('src', '');
        document.body.removeEventListener('modalClosed', clearSrc);
      }
    };
    document.body.addEventListener('modalClosed', clearSrc);
  }, true);
})();
